import React from 'react';
import { Layout, Button, Popover } from 'antd';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import { assetsRestCrudThunksForBuyer } from '../../thunks/assets_thunks';
import {
	getProtectedImageUriForBuyer,
	getProtectedImageUriFromString,
} from '../../utils/FileAccessUtils';
import { Link } from 'react-router-dom';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import Carousel, { Modal as Lightbox, ModalGateway } from 'react-images';
import { clearNavbarState, updateNavbarState } from '../../actions/navbar_actions';
import {
	generateBackLink,
	getBackLinkStates,
	getLinkWIthBackLinkParams,
} from '../../utils/HistoryUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import TransferAssetToLocationForm from '../supplier_assets_detail_page/TransferAssetToLocationForm';
import NextPreviousButton from '../next_previous_button/NextPreviousButton';
import { ASSETS_CRUD_ACTION_CREATORS } from '../../actions/assets_actions';
import { updatePaginationEntities } from '../../thunks/thunks_wrapper';
import OWButtonWithSupplierManagedLock from '../common/OWButtonWithSupplierManagedLock';
import DeleteConfirmButton from '../delete_pop_confirm/DeletePopConfirm';

require('./AssetsDetailPage.less');
const queryString = require('qs');

const { Content } = Layout;
const DEFAULT_BACK_LINK = '/buyer/assets';

class AssetsDetailPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			lightboxIsOpen: false,
			currentIndex: 0,
			manualsIncluded: false,
			backLinkTo: DEFAULT_BACK_LINK,
			backLinkText: 'Back to assets',
			transferModalVisible: false,
			fromTargetCollectionName: null,
		};
	}

	handleViewChange = (idx) => {
		this.setState({ currentIndex: idx });
	};

	openLightbox = (currentIndex = 0) => {
		this.setState({ lightboxIsOpen: true, currentIndex });
	};

	closeLightbox = () => {
		this.setState({ lightboxIsOpen: false });
	};

	componentDidMount() {
		const { getAsset, match, updateNavbar, location, asset } = this.props;

		const assetId = match.params.id;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const { backLinkText: navBackLinkText, backLinkTo: navBackLinkTo } = getBackLinkStates(
			location,
			'/buyer/assets/overview/all'
		) as any;
		updateNavbar(
			navBackLinkText || 'Back to Assets',
			navBackLinkTo || generateBackLink('/buyer/assets/overview/all', location)
		);
		const queryParams = queryString.parse(searchString);
		if (queryParams.targetCollectionName) {
			this.setState({
				fromTargetCollectionName: queryParams.targetCollectionName,
			});
		}
		if (queryParams.backlinkParams) {
			this.setState({
				loading: false,
				backLinkTo: `/buyer/assets/overview/all?${queryParams.backlinkParams}`,
			});
		} else {
			this.setState({
				loading: false,
				backLinkTo: `/buyer/assets/overview/all`,
			});
		}

		if (nullSafeGet('id', asset)) {
			if (nullSafeGet('assetModel.manuals', asset)) {
				this.setState({ manualsIncluded: true });
			} else {
				this.setState({ manualsIncluded: false });
			}
		} else {
			getAsset(assetId).then((asset) => {
				if (nullSafeGet('assetModel.manuals', asset)) {
					this.setState({ manualsIncluded: true });
				} else {
					this.setState({ manualsIncluded: false });
				}
			});
		}
	}
	componentWillUnmount(): void {
		this.props.clearNavbar();
	}

	handleTabChange = (key) => {
		const { history, match, location } = this.props;
		const assetId = match.params.id;
		const path = `/buyer/assets/detail/${assetId}/${key}`;
		history.push(`${path}?${getBackLinkStates(location, path).backLinkParams || ''}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	handleDelete = () => {
		const { history, deleteAsset, asset } = this.props;
		deleteAsset(asset).then(() => {
			history.push('/buyer/assets/overview/all');
		});
	};

	showTransferModal = () => this.setState({ transferModalVisible: true });
	hideTransferModal = () => this.setState({ transferModalVisible: false });

	onTransferSuccess = () => {
		const { getAsset, match } = this.props;
		const assetId = match.params.id;
		this.hideTransferModal();
		getAsset(assetId);
	};

	handleCopy = () => {
		const { match, history, userType, location } = this.props;
		const assetId = match.params.id;
		history.push(
			getLinkWIthBackLinkParams(
				location,
				'Back to asset',
				`/${userType}/assets/overview/new?copyFromAssetId=${assetId}`
			)
		);
	};

	onEdit = () => {
		const { history, match, userType, location } = this.props;
		const assetId = match.params.id;
		const toLink = getLinkWIthBackLinkParams(
			location,
			'Back to Asset',
			`/${userType}/assets/edit/${assetId}`
		);
		history.push(toLink);
	};

	render() {
		const {
			asset,
			assetsFetching,
			match,
			location,
			history,
			assets,
			updatePagination,
			cloneTargetCollection,
		} = this.props;
		const assetId = match.params.id;
		let tabs = [
			{
				key: 'details',
				name: 'Overview',
			},
			{
				key: 'downtimeHistory',
				name: 'Downtime History',
			},
			{
				key: 'audit',
				name: 'Audit Logs',
			},
		];
		if (this.state.manualsIncluded) {
			tabs.push({ key: 'manuals', name: 'Manuals' });
		}
		let photoUris = [];
		let lightboxPhotoUris = [];
		if (asset.images && asset.images.length) {
			photoUris = asset.images.slice(0, 4).map((assetImg) => {
				const [imgFileId, imgFileName] = assetImg.split('/');
				return getProtectedImageUriForBuyer(imgFileId, imgFileName, 1200, 800);
			});
			lightboxPhotoUris = asset.images.map((photoString) => ({
				src: getProtectedImageUriFromString(ROLE_TYPES.BUYER)(photoString, 2400, 1600),
			}));
		}
		const fetching = assetsFetching && !nullSafeGet('id', asset);

		return (
			<div>
				<Route
					path="/buyer/assets/detail/:id"
					exact={true}
					render={() => (
						<Redirect
							to={{
								pathname: `/buyer/assets/detail/${assetId}/details`,
							}}
						/>
					)}
				/>
				<Content className="assetsDetailPage">
					{/*<ScrollToTopOnMount/>*/}
					{/*<BackTop/>*/}
					<ModalGateway>
						{this.state.lightboxIsOpen ? (
							<Lightbox onClose={this.closeLightbox}>
								<Carousel
									trackProps={{
										onViewChange: this.handleViewChange,
									}}
									views={lightboxPhotoUris}
									currentIndex={this.state.currentIndex}
								/>
							</Lightbox>
						) : null}
					</ModalGateway>

					<div className="imageLayout">
						{photoUris.map((photoUri, idx) => (
							<div
								key={idx}
								className={`imageTile imageTile${idx}`}
								style={{ backgroundImage: `url(${photoUri})` }}
							/>
						))}
						<div
							className={`imageLayout__gradientOverlay ${
								asset.isActive ? '' : 'imageLayout__gradientOverlay--darker'
							}`}
						>
							{!asset.isActive ? <div className="assetInactiveLabel">Inactive</div> : null}
							<div className="assetsDetailPage__overtitle">
								{nullSafeGet('assetType.name', asset)}
							</div>
							<h4 className="assetsDetailPage__title">{fetching ? null : asset.name}</h4>
							<SubnavTabs
								tabs={tabs}
								onChange={this.handleTabChange}
								isActive={this.checkTabActive}
							/>
							<div style={{ position: 'absolute', top: 40, right: 40 }}>
								<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_ASSETS}>
									<OWButtonWithSupplierManagedLock
										ghost={true}
										onClick={this.onEdit}
										style={{ marginRight: 16 }}
									>
										Edit
									</OWButtonWithSupplierManagedLock>
								</AccessPermissionChecker>
								<AccessPermissionChecker name={PERMISSION_NAMES.DELETE_ASSETS}>
									<DeleteConfirmButton
										onConfirm={this.handleDelete}
										title={'Are you sure you want to delete this asset?'}
									>
										<OWButtonWithSupplierManagedLock ghost={true} style={{ marginRight: 16 }}>
											Delete
										</OWButtonWithSupplierManagedLock>
									</DeleteConfirmButton>
								</AccessPermissionChecker>
								<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_ASSETS}>
									<OWButtonWithSupplierManagedLock
										ghost={true}
										onClick={this.handleCopy}
										style={{ marginRight: 16 }}
									>
										Copy and create new
									</OWButtonWithSupplierManagedLock>
									<Popover
										content={!asset.isActive ? 'Inactive assets cannot be transferred' : ''}
										trigger="hover"
									>
										<OWButtonWithSupplierManagedLock
											ghost={true}
											onClick={this.showTransferModal}
											disabled={!asset.isActive || fetching}
										>
											Transfer
										</OWButtonWithSupplierManagedLock>
									</Popover>
								</AccessPermissionChecker>
							</div>
							<div
								style={{ position: 'absolute', bottom: 40, right: 40 }}
								className="flex flex-row items-baseline"
							>
								{lightboxPhotoUris.length > 0 ? (
									<Button
										style={{ color: 'white', marginRight: 16 }}
										type="ghost"
										onClick={() => this.openLightbox()}
									>
										View Photos
									</Button>
								) : null}
								<NextPreviousButton
									key={this.state.fromTargetCollectionName}
									location={location}
									history={history}
									activeId={nullSafeGet('id', asset)}
									getEnitityUrl={(id) => `/buyer/assets/detail/${id}/details`}
									stateSlice={assets}
									targetCollectionName={this.state.fromTargetCollectionName}
									updatePagination={updatePagination}
									cloneTargetCollection={cloneTargetCollection}
									entityName="asset"
								/>
							</div>
						</div>
					</div>
					{this.props.childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
					{this.state.transferModalVisible ? (
						<TransferAssetToLocationForm
							asset={asset}
							onCancel={this.hideTransferModal}
							onSuccess={this.onTransferSuccess}
						/>
					) : null}
				</Content>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	assetsFetching: state.assets.fetching,
	asset: getEntityById(ownProps.match.params.id, state.assets),
	userType: state.session.userType,
	assets: state.assets,
});

const mapDispatchToProps = (dispatch) => ({
	getAsset: (id) => dispatch(assetsRestCrudThunksForBuyer.readOne(id)),
	deleteAsset: (entity) => dispatch(assetsRestCrudThunksForBuyer.delete(entity, 'id', null, true)),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
	clearNavbar: () => dispatch(clearNavbarState()),
	cloneTargetCollection: (from, to) =>
		dispatch(ASSETS_CRUD_ACTION_CREATORS.cloneTargetCollection(from, to)),
	updatePagination: (pagination, targetCollectionName) =>
		dispatch(
			updatePaginationEntities('buyer', 'assets', assetsRestCrudThunksForBuyer)(
				false,
				undefined,
				targetCollectionName,
				pagination,
				true
			)
		),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetsDetailPage));
